import { Box } from '@chakra-ui/react'
import styled from '@emotion/styled'

import { Option, StyledSelect } from '@/components/ui'

const pageSizeOptions = [
  { value: 5, label: '5' },
  { value: 10, label: '10' },
  { value: 25, label: '25' },
  { value: 50, label: '50' },
]

// Overwrite some of the styles
const PageSizeSelect = styled(StyledSelect)`
  .react-select__control {
    min-height: 0px;
  }
  .react-select__dropdown-indicator,
  .react-select__clear-indicator {
    padding: 5px 3px;
    padding-left: 0;
  }
  .react-select__single-value {
    overflow: visible;
    padding: 0px;
  }
`
interface PageSizeSelectIProps {
  title: string
  pageSize: number
  setPageSize: (newPageSize: number) => void
  onClick: (value: number) => void
  dataTestId?: string
}

export const PageSizeSelector = ({
  title,
  pageSize,
  setPageSize,
  onClick,
  dataTestId,
}: PageSizeSelectIProps) => {
  return (
    <Box
      alignItems='center'
      data-testid={dataTestId}
      display='flex'
      justifyContent='flex-end'
    >
      <Box as='span' mr='15px'>
        {title}
      </Box>
      <Box width='70px'>
        <PageSizeSelect
          aria-label='select page size'
          classNamePrefix='react-select'
          components={{
            IndicatorSeparator: null,
            Option,
          }}
          data-testid={dataTestId}
          defaultValue={pageSizeOptions.filter((o) => o.value === pageSize)}
          isSearchable={false}
          menuPlacement='top'
          onChange={(e: { value: number }) => {
            setPageSize(e.value)
            onClick(e.value)
          }}
          options={pageSizeOptions}
        />
      </Box>
    </Box>
  )
}
